"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateEmail = exports.isEmailTypo = void 0;
const validateEmail = (email) => email.indexOf("@") > -1 && email.indexOf(".") > -1 && email.length > 4;
exports.validateEmail = validateEmail;
const com = {
    original: "com",
    mispellings: ["co", "cm", "con", "cmo", "cim", "cim", "coo", "coo", "coom"],
};
const gmail = {
    original: "gmail",
    mispellings: [
        "gamil",
        "gmai",
        "gmaill",
        "gmal",
        "gmaul",
        "gmaol",
        "gmaik",
        "gmaii",
        "gmil",
        "gmill",
    ],
};
const hotmail = {
    original: "hotmail",
    mispellings: [
        "hotmai",
        "hotmal",
        "hotmaul",
        "hotmaol",
        "hotmaik",
        "hotmaii",
        "htmaii",
        "htmail",
    ],
};
const yahoo = {
    original: "yahoo",
    mispellings: ["yaho", "yho", "yaaho", "ahoo"],
};
const isEmailTypo = (email) => {
    const isValidEmail = validateEmail(email);
    if (!isValidEmail)
        return {
            isValidEmail: false,
            tldTypo: {
                exists: false,
                original: "",
            },
            domainTypo: {
                exists: false,
                original: "",
            },
        };
    let typeo = {
        isValidEmail: true,
        tldTypo: { exists: false, original: "" },
        domainTypo: { exists: false, original: "" },
    };
    const [_, domainAndTld] = email.split("@");
    const [domain, tld] = domainAndTld.split(".");
    let domainThatsBeenMispelled = null;
    const isMispellingOfGmail = gmail.mispellings.includes(domain);
    if (isMispellingOfGmail)
        domainThatsBeenMispelled = gmail.original;
    const isMispellingOfHotmail = hotmail.mispellings.includes(domain);
    if (isMispellingOfHotmail)
        domainThatsBeenMispelled = hotmail.original;
    const isMispellingOfYahoo = yahoo.mispellings.includes(domain);
    if (isMispellingOfYahoo)
        domainThatsBeenMispelled = yahoo.original;
    if (domainThatsBeenMispelled) {
        typeo.domainTypo.exists = true;
        typeo.domainTypo.original = domainThatsBeenMispelled;
    }
    const isMispellingOfDotCom = com.mispellings.includes(tld);
    if (isMispellingOfDotCom) {
        typeo.tldTypo.exists = true;
        typeo.tldTypo.original = com.original;
    }
    return typeo;
};
exports.isEmailTypo = isEmailTypo;
//# sourceMappingURL=validateEmail.js.map